import { render, staticRenderFns } from "./collectionDetail.vue?vue&type=template&id=3678a892&scoped=true"
import script from "./collectionDetail.vue?vue&type=script&lang=ts"
export * from "./collectionDetail.vue?vue&type=script&lang=ts"
import style0 from "./collectionDetail.vue?vue&type=style&index=0&id=3678a892&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3678a892",
  null
  
)

export default component.exports